/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineExamExamid200,
  GetApiV1ClassroomdisciplineExamExamid401,
  GetApiV1ClassroomdisciplineExamExamidPathParams,
  GetApiV1ClassroomdisciplineExamExamidQueryParams,
  GetApiV1ClassroomdisciplineExamExamidQueryResponse,
} from "../../types/classPlanningController/GetApiV1ClassroomdisciplineExamExamid.ts";
import { classroomDisciplineListItemViewModelSchema } from "../classroomDisciplineListItemViewModelSchema.ts";
import { eClassRoomDisciplinesStatusSchema } from "../eClassRoomDisciplinesStatusSchema.ts";

export const getApiV1ClassroomdisciplineExamExamidPathParamsSchema = z.object({
  examId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ClassroomdisciplineExamExamidPathParams>;

export const getApiV1ClassroomdisciplineExamExamidQueryParamsSchema = z
  .object({
    CompanyId: z.optional(z.coerce.number().int()),
    CourseId: z.optional(z.coerce.number().int()),
    ClassStudentId: z.optional(z.coerce.number().int()),
    ClassModuleId: z.optional(z.coerce.number().int()),
    DisciplineId: z.optional(z.coerce.number().int()),
    PoloId: z.optional(z.coerce.number().int()),
    Status: z.optional(
      z.array(
        z
          .lazy(() => eClassRoomDisciplinesStatusSchema)
          .describe(
            "1 = Planned | 2 = Finished | 3 = Canceled | 4 = Confirmed | ",
          ),
      ),
    ),
    DateStart: z.optional(z.string().datetime()),
    DateEnd: z.optional(z.string().datetime()),
    Teacher: z.optional(z.string()),
    SortField: z.optional(z.string()),
    SortDirection: z.optional(z.string()),
    PageNumber: z.optional(z.coerce.number().int()),
    PageSize: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineExamExamidQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineExamExamid200Schema = z.array(
  z.lazy(() => classroomDisciplineListItemViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineExamExamid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineExamExamid401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineExamExamid401>;

export const getApiV1ClassroomdisciplineExamExamidQueryResponseSchema = z.lazy(
  () => getApiV1ClassroomdisciplineExamExamid200Schema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineExamExamidQueryResponse>;
